module.exports = __webpack_public_path__ + "static/media/filterIconDark.9e52c7fd.svg";